<template>
  <v-card class="ma-2" max-width="300px" elevation-24>
    <v-card-title class="py-0">
      <span class="title font-weight-medium" style="word-break: normal;">
        <a :href="singleItem.viewItemURL[0]" target="_blank" style="text-decoration: none;">{{ singleItem.title[0] }}</a>
      </span>
    </v-card-title>
    <v-container fluid class="py-0 px-4">
      <!-- <v-layout wrap justify-space-around class="">
        <v-layout column align-center>
          <v-flex xs12 sm3>
            <v-img contain height="200" width="150" :src="singleItem.galleryURL[0]"></v-img>
          </v-flex>
        </v-layout>
        <v-flex xs12 sm3>
          <v-text-field class="body-2 font-weight-medium" label="Listing Type" v-model="listingType"></v-text-field>
          <v-text-field class="body-2 font-weight-medium" label="Current Price" v-model="sellingPrice"></v-text-field>
        </v-flex>
        <v-flex xs12 sm3>
          <v-text-field class="body-2 font-weight-medium" label="Start Time" v-model="localStartTime"></v-text-field>
          <v-text-field class="body-2 font-weight-medium" label="End Time" v-model="localEndTime"></v-text-field>
        </v-flex>
      </v-layout> -->
      <v-row class="pt-0" justify="space-around">
          <v-col class="py-1" cols="12" xs="10" align="center">
            <v-img contain height="auto" width="90vw" :src="singleItem.galleryURL[0]"></v-img>
          </v-col>
          <v-col class="py-0" cols="12" xs="4">
            <v-text-field class="body-2 font-weight-medium" label="Listing Type" v-model="listingType"></v-text-field>
            <v-text-field class="body-2 font-weight-medium" label="Current Price" v-model="sellingPrice"></v-text-field>
          <!-- </v-col>
          <v-col cols="12" xl="12" lg="" md="3" sm="4" xs="4"> -->
            <v-text-field class="body-2 font-weight-medium" label="Start Time" v-model="localStartTime"></v-text-field>
            <v-text-field class="body-2 font-weight-medium" label="End Time" v-model="localEndTime"></v-text-field>
          </v-col>
      </v-row>
    </v-container>
    <v-card-actions>
      <v-spacer/>
      <v-btn text>Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { getSalePrice, setDateTimeFormat } from "@/utilities.js"

  export default {
    name: "singleItem",
    props: ["singleItem"],
    data () {
      return {}
    },
    computed: {
      listingType () {
        return "Buy It Now"
      },
      sellingPrice () {
        return getSalePrice(this.singleItem)
      },
      localStartTime () {
        return setDateTimeFormat(this.singleItem.listingInfo[0].startTime[0])
        // return "2/21/2020 03:31PM"
      },
      localEndTime () {
        return setDateTimeFormat(this.singleItem.listingInfo[0].endTime[0])
        // return "2/21/2020 03:31PM"
      }
    }
  }
</script>

<style scoped>

</style>
